export const MONTH_NAMES_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const MONTH_NAMES_LONG = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const CUSTOMER_FEATURE_FLAG_NAME = {
  DND_NEW_VERSION_ENABLED: "dnd_new_version_enabled",
  MRM_URL_FILTER_MAPPING_ENABLED: "mrm_url_filter_mapping_enabled",
  MRM_SORT_TABLE_ENABLED: "mrm_sort_table_enabled",
  ENABLE_ASYNC_UPLOAD: "enable_async_upload",
  EMISSIONS_URL_FILTER_MAPPING_ENABLED: "emissions_url_filter_mapping_enabled",
  SUBSCRIPTION_FLEXI_COLUMN_ENABLED: "subscription_flexi_column_enabled",
  SHIPMENT_USER_COLUMN_ENABLED: "shipment_user_column_enabled",
  METERING_LIST_ITEM_TABLE_ENABLED: "metering_list_item_table_enabled",
  CONTROL_TOWER_ENABLED: "control_tower_enabled",
  ENABLE_CENTRALISED_REPORTING: "enable_centralised_reporting",
  ENABLE_CENTRALISED_REPORTING_FAST_FOLLOW_UP: "enable_centralised_reporting_fast_follow_up",
  ENABLE_ASYNC_DOWNLOAD: "vite_async_reporting",
  UAM_UI_ENABLED: "uam_enabled",
  ENABLE_TERMINAL_DISRUPTIONS_API: "enable_terminal_disruptions_api",
  CONTAINER_TYPE_CONVERSION_ENABLED: "container_type_conversion_enabled",
  LOCKED_UPSELL_FEATURE_ENABLED: "locked_upsell_feature_enabled",
  NEW_USER_COLUMN_BU_PT_ENABLED: "enabled_new_user_column_bu_pt",
  SHIPMENT_MAP_ENABLED: "enable_vessel_info",
  BOOKING_VOLUME_ENABLED: "enable_booking_volume_product",
  CUSTOMER_NAME_FILTER_ENABLED: "customer_name_filter_enabled",
  CARRIER_PERFORMANCE_ENABLED: "carrier_performance_enabled",
  AIR_NEW_UI_ENABLED: "new_air_experience",
  UAM_ENABLED: "uam_enabled",
  MRM_DISRUPTION_FILTERS_ENABLED: "mrm_disruption_filters_enabled",
  MRM_DISRUPTION_CATEGORY_MULTISELECT_ENABLED: "mrm_disruption_category_multiselect_enabled",
  MRM_INITIAL_ETA_ETD_ENABLED: "mrm_initial_eta_etd_enabled",
  PROD_MESSAGE_ENABLED: "prod_message_enabled",
  PENULTIMATE_ETA_ENABLED: "penultimate_eta_enabled",
  DATE_TYPE_STANDARDISATION_ENABLED: "date_type_standardisation_enabled",
  ENABLE_TRACK_AND_TRACE_VIEW: "enable_track_and_trace_view",
  PO_RISK_ENABLED: "po_risk_enabled",
  SHIPMENT_ID_CS_COLUMN_ENABLED: "shipment_id_cs_column_enabled"
};

export const CUSTOMER_CODES_FILTER_KEY = "customerCodes";

export const UPLOAD_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const THOUSAND = 1000;
export const MILLION = 1000000;
export const EMPTY_VALUE = "—";
export enum Capability {
  SHIPMENTS = "shipment",
  AIR_SHIPMENTS = "airShipment",
  "D&D" = "dnd",
  MAERSK_RISK_MANAGEMENT = "mrm",
  PORT_CONGESTION = "portCongestion",
  EMISSIONS = "Emission"
}
